var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      ref: "container",
      staticClass: "collapsible",
      class: { "collapsible--collapsed": !_vm.expanded }
    },
    [
      _c(
        "header",
        {
          staticClass: "collapsible__header",
          class: { "collapsible__header--preview-only": _vm.previewOnly }
        },
        [
          _c(
            "h2",
            { staticClass: "collapsible-title heading-with-separator" },
            [
              _c(
                "span",
                {
                  staticClass: "heading-with-separator__inner",
                  class: { "heading-error": _vm.isError }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.titleText) +
                      "\n                "
                  ),
                  _vm.isError
                    ? _c(
                        "svg",
                        {
                          staticClass: "exception-icon",
                          attrs: {
                            height: _vm.exceptionIconSize,
                            width: _vm.exceptionIconSize
                          }
                        },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#exclamation-heavy" }
                          })
                        ]
                      )
                    : _vm._e()
                ]
              )
            ]
          ),
          !_vm.previewOnly
            ? _c(
                "base-icon-button",
                {
                  staticClass: "collapsible__toggle",
                  attrs: {
                    secondary: "",
                    "title-text": _vm.toggleLabel,
                    disabled: _vm.disabled
                  },
                  on: { click: _vm.toggle }
                },
                [
                  _c("svg", { attrs: { width: "12", height: "8" } }, [
                    _c("use", { attrs: { "xlink:href": "#chevron-down" } })
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c("div", { staticClass: "collapsible__content" }, [
        _c(
          "div",
          {
            staticClass: "collapsible__content-inner",
            class: { "collapsible__content-inner--disabled": _vm.disabled }
          },
          [_vm._t("default")],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }